export default class Compromisso {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.bancoId = 0;
        this.planoContaId = 0;
        this.planoContaItemId = 0;
        this.projetoId = 0;
        this.atividadeId = null;
        this.atividadeItemId = null;
        this.fornecedorId = 0;
        this.descricao = '';
        this.situacao = 'A';
        this.dataLancamento = new Date().yyyymmdd();
        this.dataEmissao = new Date().yyyymmdd();
        this.dataCompetencia = new Date().yyyymmdd();
        this.dataVencimento = new Date().yyyymmdd();
        this.dataPagamento = null;
        this.valor = 0;
        this.desconto = 0;
        this.juros = 0;
        this.valorFinal = 0;
        this.formaPagamento = 0;
        this.observacao = '';
        this.numeroDocumento = '';
        this.numeroCheque = 0;
        this.nomeComprovante = '';
        this.recorrencia = 1;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.bancoId = model.bancoId; 
        this.planoContaId = model.planoContaId;
        this.planoContaItemId = model.planoContaItemId;
        this.projetoId = model.projetoId;
        this.projeto = model.projeto;
        this.atividadeId = model.atividadeId;
        this.atividadeItemId = model.atividadeItemId;
        this.fornecedorId = model.fornecedorId;
        this.fornecedor = model.fornecedor;
        this.descricao = model.descricao;
        this.situacao = model.situacao;
        this.dataLancamento = new Date(model.dataLancamento).yyyymmdd();
        this.dataVencimento = new Date(model.dataVencimento).yyyymmdd();
        this.dataEmissao = new Date(model.dataEmissao).yyyymmdd();
        this.dataCompetencia = model.dataCompetencia ? new Date(model.dataCompetencia).yyyymmdd() : null;
        this.dataPagamento = model.dataPagamento ? new Date(model.dataPagamento).yyyymmdd() : null;
        this.valor = model.valor;
        this.desconto = model.desconto;
        this.juros = model.juros;
        this.valorFinal = model.valorFinal;
        this.formaPagamento = model.formaPagamento;
        this.observacao = model.observacao;
        this.numeroDocumento = model.numeroDocumento;
        this.numeroCheque = model.numeroCheque;
        this.nomeComprovante = model.nomeComprovante;
        this.recorrencia = model.recorrencia;
        
    }
}